import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-KM9EQDBMQH';

let gaBootstrapped = false;

function ensureGaLoaded() {
  if (typeof window === 'undefined') return;

  // Ensure dataLayer + gtag stub exist (queues calls until gtag.js loads)
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer!.push(arguments);
    };

  // Inject gtag.js only once per page load.
  const existingScript = document.querySelector<HTMLScriptElement>(
    `script[data-ga-measurement-id="${GA_MEASUREMENT_ID}"]`,
  );

  if (!existingScript) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.setAttribute('data-ga-measurement-id', GA_MEASUREMENT_ID);
    document.head.appendChild(script);
  }

  // Guard against React StrictMode double-invocation in development.
  if (!gaBootstrapped) {
    window.gtag('js', new Date());
    gaBootstrapped = true;
  }
}

/**
 * Loads GA4 (gtag.js) only when mounted.
 * Intended to be rendered only on the `/qq/*` route.
 */
export default function QQAnalytics() {
  const location = useLocation();

  // Load GA script when entering /qq.
  useEffect(() => {
    if (!location.pathname.startsWith('/qq')) return;
    ensureGaLoaded();
  }, [location.pathname]);

  // Track SPA navigations for /qq/*.
  useEffect(() => {
    if (!location.pathname.startsWith('/qq')) return;
    ensureGaLoaded();

    // `config` triggers a page_view by default in GA4.
    const page_path = `${location.pathname}${location.search}`;
    window.gtag?.('config', GA_MEASUREMENT_ID, { page_path });
  }, [location.pathname, location.search]);

  return null;
}
